<template>
  <div class="wishlist" v-if="displayWishlist">
    <!-- FIXME: Not working if adding a wishlist -->
    <button class="wishlist__add-button" type="button" @click="callWSWiswhlist">
      <!-- TODO: Add animation with dynamic class -->
      <i class="wishlist__heart" :class="{ 'wishlist__heart--bouncing': isBouncing }">
        <svg v-if="wishlistState" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="-68 169 538 448" style="enable-background:new -68 169 538 448;" xml:space="preserve">
        <g>
          <g>
            <path fill="#FFB400" d="M416.7,223.5C391.5,198,356.8,184,319,184c-52.9,0-93.7,25.5-118,73.7C176.7,209.4,135.9,184,83,184
              c-37.8,0-72.5,14-97.7,39.5C-41.1,250.2-55,286.8-55,329.2c0,51,32.4,107,96.2,166.6c57.9,54,121.3,92,133.5,99
              c5.1,2.9,16.3,9.4,16.3,9.4l4.2,2.4c3.6,2.1,8,2.1,11.6,0l4.2-2.4c0,0,11.2-6.5,16.3-9.4c12.1-7.1,75.6-45,133.5-99
              c63.9-59.6,96.2-115.7,96.2-166.6C457,286.8,443.1,250.2,416.7,223.5z"/>
          </g>
        </g>
        </svg>
      <svg v-if="!wishlistState" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="-68 169 538 448" style="enable-background:new -68 169 538 448;" xml:space="preserve">
        <g>
          <g>
            <path fill="#48494D" d="M416.7,223.5C391.5,198,356.8,184,319,184c-52.9,0-93.7,25.5-118,73.7C176.7,209.4,135.9,184,83,184
              c-37.8,0-72.5,14-97.7,39.5C-41.1,250.2-55,286.8-55,329.2c0,51,32.4,107,96.2,166.6c57.9,54,121.3,92,133.5,99
              c5.1,2.9,16.3,9.4,16.3,9.4l4.2,2.4c3.6,2.1,8,2.1,11.6,0l4.2-2.4c0,0,11.2-6.5,16.3-9.4c12.1-7.1,75.6-45,133.5-99
              c63.9-59.6,96.2-115.7,96.2-166.6C457,286.8,443.1,250.2,416.7,223.5z M333.5,466.6c-54.8,51.1-114.8,87-126.3,93.7
              c-0.1,0.1-0.2,0.1-0.4,0.2c-3.6,2.1-8,2.1-11.6,0c-0.1-0.1-0.3-0.1-0.4-0.2c-11.5-6.7-71.5-42.6-126.3-93.7
              C13.9,415.6-15,368.1-15,329.2c0-62,40.3-105.3,98-105.3c37.5,0,64.3,16.6,81.8,50.8c10.8,21,14.5,42.6,15.7,51.7
              c0.4,3.1,1.5,6,3.2,8.6l0,0c8.1,12.4,26.3,12.4,34.5,0l0-0.1c1.7-2.6,2.8-5.5,3.2-8.6c1.2-9,4.9-30.1,15.2-50.7
              c17.3-34.4,44.9-51.8,82.3-51.8c57.7,0,98,43.3,98,105.3C417,368.1,388.1,415.6,333.5,466.6z"/>
          </g>
        </g>
        </svg>
      </i>
      <span class="screen-reader-text--archive">{{ translations.addToWishlist }}</span>
    </button>
  </div>
</template>
<style scoped lang="scss">
  .single-box__wishlist .wishlist__heart svg {
    width: 2.6rem;
    height: 2.5rem;
  }
</style>
<script>
export default {
  name: "KaaliWishlist",
  data() {
    return {
      forceState: null,
      isBouncing: false,
      displayWishlist: ws_vue_store.display_wishlist === "1",
      translations: {
        addToWishlist: ws_vue_store.translations.add_to_wishlist,
        removeFromWishlist: ws_vue_store.translations.remove_from_wishlist
      }
    };
  },
  props: {
    productId: Number,
    inWishlist: Boolean
  },
  computed: {
    wishlistState() {
      return this.forceState !== null ? this.forceState : this.inWishlist;
    }
  },
  mounted: function(){
    let that = this;
    document.addEventListener('click', (event) => {
      if (!event.target.closest('.js-remove-product-from-favorites')) return;
      const currentTarget = event.target.closest('.js-remove-product-from-favorites');
      let removedProductId = currentTarget.getAttribute('data-product_id');
      if(removedProductId){
        if(removedProductId == that.productId) that.forceState = false;
      }
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('.js-clear-products-from-favorites')) return;
      const currentTarget = event.target.closest('.js-clear-products-from-favorites');
      if(currentTarget) that.forceState = false;
    });
  },
  methods: {
    async callWSWiswhlist() {
      const self = this;
      this.forceState = this.forceState !== null ? !this.forceState : !this.inWishlist;
      this.isBouncing = true;
      setTimeout(() => {
        this.isBouncing = false;
      }, 1500);
      await window.wishlistController.constructor
        .sendToggleWishlist(this.productId)
        .then(response => {
          const foundIndex = self.$store.state.products.findIndex(product => {
            return product.id === self.productId;
          });
          if (foundIndex !== -1) {
            const helperProduct = self.$store.state.products[foundIndex];
            helperProduct.inWishlist = response.data.is_in_wishlist;
            self.$set(self.$store.state.products, foundIndex, helperProduct);
          }
          self.forceState = response.data.is_in_wishlist;
          setTimeout(() => {
            self.isBouncing = false;
          }, 1500);
        })
        .catch(err => {
          console.error(err);
        });
    }
  }
};
</script>
